import { LoadableRoute } from 'routes/utils/loadable';

export const PublicCompanyPortalContainer = LoadableRoute({
  loader: () =>
    import(
      /* webpackChunkName: "PublicCompanyPortal" */ './PublicCompanyPortal'
    ),
});
